export const clamp = function () {
  let val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  let min = arguments.length > 1 ? arguments[1] : undefined;
  let max = arguments.length > 2 ? arguments[2] : undefined;
  return Math.max(min, Math.min(val, max));
};